/** Formata e retorna o nome de um plano. Se o nome não inclui a palavra "Plano", é inserida antes do nome definido. */
export default function formatPlanoNome(nome: string) {
  return new RegExp(/plano/gi).test(nome)
    ? nome.trim()
    : `Plano ${nome.trim()}`;
}
